import {CompanyStatistics} from '@/types/company';
import {CompanyUser} from '@/types/user';
import {createContext} from 'react';

type CompanyContextType = {
  companyStatistics: CompanyStatistics | null;
  companyEmployees: CompanyUser[] | null;
  refreshCompanyData: () => void;
};

const defaultContext: CompanyContextType = {
  companyStatistics: null,
  companyEmployees: null,
  refreshCompanyData: () => {
    //
  }
};

const CompanyContext = createContext<CompanyContextType>(defaultContext);

export default CompanyContext;
